import { definition } from "@uesio/ui"
import File, { type FileUtilityProps } from "../file/file"
import FileImage, { type FileImageProps } from "../fileimage/fileimage"
import FileVideo, { type FileVideoProps } from "../filevideo/filevideo"

type FilePreviewProps =
  | (FileImageProps & { fileInfo?: { mimetype?: `image/${string}` } })
  | (FileVideoProps & { fileInfo?: { mimetype?: `video/${string}` } })
  | (FileUtilityProps & { fileInfo?: { mimetype?: string } })

const FilePreview: definition.UtilityComponent<FilePreviewProps> = (props) => {
  const { fileInfo } = props
  const [typeSubtype] = (fileInfo?.mimetype || "").split(";")
  const [mimeType] = typeSubtype.split("/")

  switch (mimeType) {
    case "image":
      return <FileImage {...props} />
    case "video":
      return <FileVideo {...props} />
    default:
      return <File {...props} />
  }
}

export default FilePreview
